import { Controller } from "@hotwired/stimulus"
import { postJson } from "../utils/fetch_with_csrf"

export default class extends Controller {
  static values = {
    targetUrl: String,
    redirectPath: String,
    product: String
  }

  async open(event) {
    event.preventDefault()

    if (!this.targetUrlValue) {
      alert("Unable to authenticate. Please try again or contact support.")
      return
    }

    try {
      const data = await postJson('/auth/axle/token', { product: this.productValue || 'academics' })
      if (data.token) {
        let url = `${this.targetUrlValue}?token=${data.token}`
        if (this.redirectPathValue) {
          url += `&redirect=${encodeURIComponent(this.redirectPathValue)}&redirect_with_token=true`
        }
        window.open(url, '_blank')
      } else {
        alert("Unable to authenticate. Please try again or contact support.")
      }
    } catch (error) {
      console.error("Failed to retrieve authentication token:", error)
      alert("Unable to authenticate. Please try again or contact support.")
    }
  }
}
